module.exports = __webpack_public_path__ + "media/icon_transaction/dog_3-f4a508a4.png";